import { default as gql } from 'graphql-tag';

export const addonsQuery = gql`
  query addons {
    addons {
      id
      keyword
    }
  }
`;

export const ANALYTICS_LIST = gql`
  query analytics {
    analytics {
      id
      name
      description
      group
      clientAnalytics {
        clientId
      }
    }
  }
`;

export const ANALYTIC = gql`
  query analytic($id: Int!, $clientId: Int!, $userId: Int!) {
    analytic(id: $id, clientId: $clientId, userId: $userId) {
      id
      name
      datalakeid
      description
    }
  }
`;

export const AVAILABLE_ANALYTICS = gql`
  query availableAnalytics($clientId: Int!, $userId: Int!) {
    availableAnalytics(clientId: $clientId, userId: $userId) {
      id
      name
      group
      datalakeid
      description
    }
  }
`;

export const Analytics_For_Client = gql`
  query analyticsForClient {
    analyticsForClient {
      id
      name
      description
      group
      clientAnalytics {
        clientId
      }
    }
  }
`;